import { render, staticRenderFns } from "./VideoJSRecordGallery.vue?vue&type=template&id=0d7ba934&"
import script from "./VideoJSRecordGallery.vue?vue&type=script&lang=js&"
export * from "./VideoJSRecordGallery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports